export default __webpack_public_path__ + "static/media/pikachu.c6776310.jpg";